// Cor da faixa de contexto na visão de um cliente: cor primária (marca) quando é
// um cliente, e cinza quando é um lead (cliente_prospect). Usada na barra do topo
// do conteúdo e no topo da sidebar de cliente.
export const ACCENT_LEAD = '#8e8e8e'
export const ACCENT_CLIENTE = 'var(--primary)'

export function clienteAccentColor(client) {
  return client && client.cliente_prospect ? ACCENT_LEAD : ACCENT_CLIENTE
}
